module.exports = __webpack_public_path__ + "img/intro_4.547b991a.jpg";